(() => {
  angular
    .module('gm.common.token', [])
    .factory('GmyToken', GmyToken);

  function GmyToken(
    GmyCookies,
    Environment
  ) {
    'ngInject';

    const TOKEN_COOKIE_NAME = '_bitgold_token_';
    const TOKEN_TYPE_COOKIE_NAME = '_bitgold_token_type';
    const TOKEN_TYPE_SESSION = 'session';
    const TOKEN_TYPE_PERSISTED = 'persisted';

    const removeListeners = [];
    const setListeners = [];
    let token = null;

    return {
      getToken,
      hasToken,
      onRemove,
      onSet,
      persistToken,
      removeToken,
      setToken,
    };

    function getToken() {
      if (!token) {
        token = GmyCookies.set(TOKEN_COOKIE_NAME, undefined, { domain: `.${Environment.domain}` });
      }

      return token;
    }

    function hasToken() {
      return !!this.getToken();
    }

    function onRemove(cb) {
      removeListeners.push(cb);
    }

    function onSet(cb) {
      setListeners.push(cb);
    }

    function persistToken() {
      GmyCookies.set(TOKEN_COOKIE_NAME, token, {
        expires: 31,
        path: '/',
        domain: `.${Environment.domain}`
      });
      GmyCookies.set(TOKEN_TYPE_COOKIE_NAME, TOKEN_TYPE_PERSISTED, {
        expires: 31,
        path: '/',
        domain: `.${Environment.domain}`
      });
    }

    function removeToken() {
      GmyCookies.remove(TOKEN_COOKIE_NAME, {
        path: '/',
        domain: `.${Environment.domain}`
      });
      GmyCookies.remove(TOKEN_TYPE_COOKIE_NAME, {
        path: '/',
        domain: `.${Environment.domain}`
      });

      if (token) {
        token = null;
        removeListeners.forEach(cb => cb());
      }
    }

    function setToken(t) {
      if (t) {
        token = t;

        if (GmyCookies.get(TOKEN_TYPE_COOKIE_NAME) !== TOKEN_TYPE_PERSISTED) {
          GmyCookies.set(TOKEN_COOKIE_NAME, token, {
            path: '/',
            domain: `.${Environment.domain}`
          });
          GmyCookies.set(TOKEN_TYPE_COOKIE_NAME, TOKEN_TYPE_SESSION, {
            path: '/',
            domain: `.${Environment.domain}`
          });
        } else {
          persistToken();
        }

        setListeners.forEach(cb => cb());
      } else {
        removeToken();
      }
    }
  }
})();
